var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor-wrapper"},[(!_vm.isMonacoLoaded)?_c('div',{staticClass:"loading-message"},[_vm._v("\n    Loading editor...\n  ")]):_c('div',{attrs:{"id":'editor-container-' + _vm.suffix}})])}
var staticRenderFns = []

export { render, staticRenderFns }